
import React, { useState, useEffect } from 'react';
import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';

interface DaySelectorProps {
  register: any;
  setValue: (name: string, value: any) => void;
  watch: (name: string) => any;
}

export const DaySelector = ({ register, setValue, watch }: DaySelectorProps) => {
  const weekDays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ];
  
  // State to track selected days
  const [selectedDays, setSelectedDays] = useState<string[]>(watch('selectedDays') || []);
  
  // Update form value when selectedDays changes
  useEffect(() => {
    setValue('selectedDays', selectedDays);
  }, [selectedDays, setValue]);

  const handleDayChange = (day: string, checked: boolean) => {
    setSelectedDays(prev => {
      if (checked) {
        return [...prev, day];
      } else {
        return prev.filter(d => d !== day);
      }
    });
  };

  return (
    <div className="space-y-2">
      <Label>Select Days</Label>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
        {weekDays.map((day) => (
          <div key={day} className="flex items-center space-x-2">
            <Checkbox 
              id={day} 
              checked={selectedDays.includes(day)}
              onCheckedChange={(checked) => handleDayChange(day, checked as boolean)}
              className="bg-[#1e293b]"
            />
            <Label htmlFor={day} className="cursor-pointer">{day}</Label>
          </div>
        ))}
      </div>
    </div>
  );
};
